<template>
  <div class="app-wrapp">
    <section class="bg-clay">
      <div class="article-wrapper">
        <div class="article-head article-head--a5">
          <h2 class="article-head__title article-head__title--a5">
            <div class="animated fadeInLeft" >
              {{ 'Детей по всей России разлучали с братьями и сестрами в школах и детских садах. Как эту ситуацию удалось исправить?' | typograf }}
            </div>
            <div class="article-head__line article-head__line--51 img-w">
              <img src="@/assets/img/article5/line1.png" alt="">
            </div>
          </h2>
          <div class="article-head__img article-head__img--a5 img-w animated fadeInBottomRight">
            <img src="@/assets/img/article5/img1.png" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="article-text bg-clay">
      <div class="mobile-hidden article__img article__img1 img-w animated fadeInRight">
        <img src="@/assets/img/article5/img4.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img2 img-w" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article5/img6.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt2">
        <h3 class="article-text__h3" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Мне прямо в глаза сказали: \“Идите в коррекционную школу\”»' | typograf }}
        </h3>
        <p class="article-text__subtitle" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В жизни каждого маленького россиянина наступает момент, когда он надевает новенькую школьную форму, ранец и идет в первый раз в первый класс. Это всегда радостный и волнующий момент. Кто будут его одноклассники? Строгой ли окажется первая учительница? Насколько сложно будут даваться знания? И, конечно, хочется встретить этот день с друзьями, которых уже успел завести в детском саду, и со старшим братом или сестрой, которые всегда поддержат в сложную минуту. И хорошо бы школа была поближе к дому.' | typograf }}
        </p>
        <p class="article-text__enlarged" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В большинстве случаев так и получается, но бывают и неожиданные проблемы.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Так случилось у Елены Кульгиной из Новосибирска. Ее семья — как раз из тех, что обычно показывают в рекламе или рисуют в учебниках: мама, папа, старший сын и младшая дочь.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'И профессии у них практически эталонные: отец работает на заводе, а сама Елена — картограф-геодезист. Сын учится в математическом классе с уклоном в изучение точных наук, а дочь до последнего года ходила в садик.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Но, как это обычно бывает, в идеальных на первый взгляд семьях есть свои сложности. Младшая дочь до поры до времени ничем не отличалась от сверстников. Но годы шли, ее одногруппники уже бегло разговаривали, а вот у нее с речью до сих пор есть небольшие сложности.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Сын Кульгиных учится в школе прямо рядом с домом. Это очень удобно, поэтому когда подошла пора зачислять в школу младшую дочь, выбор был очевиден.' | typograf }}
        </p>
        <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
          <div class="article-text__quote-icon img-w">
            <img src="@/assets/img/quote-black.png" alt="">
          </div>
          {{ '«Я хотела устроить младшего ребенка в ту же школу, в которую ходил старший, потому что это два соседних здания», — говорит Кульгина.' | typograf }}
        </div>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[0]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Узнав о том, что у девочки есть особенности развития, на собеседовании завуч отнеслась к перспективе ее зачисления в школу негативно.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img3 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article5/img2.png" alt="">
        </div>
        <div class="mobile-hidden article__img article__img8 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article5/img7.png" alt="">
        </div>
       <!-- <div class="article__line article__line2 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article5/line2.png" alt="">
        </div>-->
        <div class="article-wrapper article-wrapper--shifted">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но отказать в приеме по этому поводу она не могла — ведь существует закон, обеспечивающий приоритетное право при зачислении братьев и сестер в одно учебное или воспитательное заведение.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Президент Владимир Путин подписал его еще в декабре 2019 года. Мера была направлена на укрепление семьи и обеспечение реализации прав ребенка на достойные условия содержания, воспитания и развития. Инициатива кардинально изменила жизнь многодетных семей, ведь развозить по разным учебным заведениям и двоих-то детей сложно, что уж говорить о троих и более.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Подобные правила существовали до этого в отдельных регионах, однако единого федерального закона не было, что вело к неразберихе, — скажем, прокуратура Самарской области постановила, что желание властей региона обеспечить приоритет одним детям нарушает права других. После принятия в 2019 году единого федерального правила подобных инцидентов больше не было.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Как отмечала тогда член комитета Государственной Думы по образованию и науке Алена Аршинова, закон был позитивно воспринят людьми, «мера была очень востребована и понятна всем». ' | typograf }}
          </p>
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[1]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.05*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Девочка и ее мама были формально зарегистрированы на квартире у родственников, а не по месту жительства.' | typograf }}
          </p>
        </div>
      </div>
      <div class="mobile-hidden article__img article__img10 img-w" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article5/img8.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--pb2">
        <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
          <div class="article-text__quote-icon img-w">
            <img src="@/assets/img/quote-black.png" alt="">
          </div>
          {{ '«Я привела ребенка на собеседование, и завуч начальной школы прямо в глаза нам сказала: “Идите в коррекционную школу”», — рассказывает Елена.' | typograf }}
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В то время право преимущественного приема в учебное или воспитательное заведение получали дети, проживающие в одной семье и прописанные при этом по одному адресу. Это, опять же, в некоторых случаях приводило к проблемам: иногда бывало так, что детей из одной семьи регистрировали по разным адресам — как это было у Елены Кульгиной.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Родителям приходилось собирать документы, подтверждающие проживание ребенка на той же жилплощади, что и его старшие брат или сестра, иначе им могли отказать в приоритетном праве на прием в школу и отправить каждого ребенка учиться по месту регистрации.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[2]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Отправить ребенка с особенностями развития в школу, находящуюся вдали от дома, Кульгины себе позволить не могли. Отдавать сообразительную девочку, которая просто пока не очень хорошо говорит, в коррекционную школу, которая тоже находится неблизко, очень не хотелось.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Ведь это значило, что дочь придется каждое утро возить на занятия через полгорода, а потом забирать оттуда и везти домой. Для маленькой школьницы это огромная нагрузка, не говоря уже о хлопотах для родителей.' | typograf }}
        </p>
        <Loading :class="{'is-loading-animated': isLoading}" />
        <div class="observer-move"></div>
        <Layers />
      </div>
    </section>

    <section id="element-container" class="article-text article-text--blue article-text--blue3 -no-blue">
      <div id="element-content">
        <div class="article-wrapper article-wrapper--inner article-wrapper--inner-fot">
          <h3 id="element" class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Закон поможет избежать кучи проблем»' | typograf }}
          </h3>
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но теперь эта проблема решена: 2 июля Владимир Путин подписал поправки в законодательство, обязывающие зачислять братьев и сестер, полнородных или неполнородных, в одну школу или детский сад вне зависимости от места их регистрации. Соответствующие изменения были внесены в Семейный кодекс и закон «Об образовании».' | typograf }}
          </p>
          <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[3]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По словам члена комитета по труду, социальной политике и делам ветеранов Светланы Бессараб, «в один садик, в одну школу отвезти детей гораздо проще, чем развозить по всему городу». ' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Она отметила, что поправки окажут психологическую поддержку детям, которым комфортнее учиться рядом с братьями и сестрами. Если учебное заведение не желает предоставлять семье приоритет при зачислении братьев и сестер, Бессараб призвала родителей и опекунов обращаться к своим депутатам, которые в рамках депутатского контроля рассмотрят их обращение и примут соответствующие меры.' | typograf }}
          </p>
        </div>
        <div class="article-text__shifted-box">
          <div class="mobile-hidden article__img article__img4 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article5/img3.png" alt="">
          </div>
          <div class="mobile-visible article__img article__img4 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article5/img3-mob.png" alt="">
          </div>
          <div class="mobile-hidden article__img article__img12 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article5/img10.png" alt="">
          </div>
          <!-- <div class="article__line article__line3 img-w"  v-animate-onscroll="'animated fadeInLeft'">
             <img src="@/assets/img/article5/line3.png" alt="">
           </div>-->
          <div class="article-wrapper article-wrapper--pb article-wrapper--mt article-wrapper--inner article-wrapper--shifted-right">
            <div class="article-text__quote article-text__quote--blue-nm" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[4]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Елена Кульгина, мама девочки с особенностями развития из Новосибирска, твердо уверена, что от этого выиграют не только ее дети, которые теперь смогут учиться в одной школе рядом с домом, но и многие другие.' | typograf }}
            </p>
            <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
              <div class="article-text__quote-icon img-w">
                <img src="@/assets/img/quote.png" alt="">
              </div>
              {{ '«Тут ведь все упиралось только в прописку. Если ребенок не относится к этой школе, его не брали — несмотря на то, что там учится старший. Этот закон, несомненно, очень важен, он поможет избежать кучи проблем», — говорит она.' | typograf }}
            </div>
            <div class="article-text__quote article-text__quote--blue article-text__quote--blue-nm" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[5]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'К категории приоритетного зачисления как раз относятся братья и сестры детей, уже учащихся в этой школе, вне зависимости от их регистрации по месту жительства.' | typograf }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="article-text">
      <div class="article-wrapper article-wrapper--mt">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Когда дети вместе, они могут друг друга поддержать»' | typograf }}
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{ 'По словам Елены Кульгиной, необходимость развозить братьев и сестер по разным школам и детским садам отнимала у семьи много времени и средств. К тому же она мешала нормальной социализации детей.' | typograf }}
        </p>
        <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
          <div class="article-text__quote-icon img-w">
            <img src="@/assets/img/quote.png" alt="">
          </div>
          {{ '«Ведь это же естественно — когда дети вместе, они могут друг друга поддерживать, заводить общих друзей», — рассуждает она.' | typograf }}
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">{{ 'Теперь, когда этот вопрос законодательно урегулирован, администрации школ и детских садов не имеют права отказывать родителям в таких случаях из-за наличия прямой нормы, зафиксированной в законодательстве.' | typograf }}
        </p>
        <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[6]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
      </div>
      <div class="article-text__shifted-box">
        <div class="mobile-hidden article__img article__img9 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article5/img5.png" alt="">
        </div>
        <div class="mobile-visible article__img article__img9 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article5/img5-mob.png" alt="">
        </div>
        <div class="mobile-hidden article__img article__img11 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article5/img11.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted">
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Семейное законодательство исходит из необходимости укрепления семьи, построения семейных отношений на чувствах взаимной любви и уважения, взаимопомощи и ответственности перед семьей всех ее членов, недопустимости произвольного вмешательства кого-либо в дела семьи, обеспечения беспрепятственного осуществления членами семьи своих прав, возможности судебной защиты этих прав», — гласит первая статья Семейного кодекса России.' | typograf }}
          </p>
          <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Это не простые слова, а руководство к действию, используемое авторами законопроектов, которые вносятся на рассмотрение в Государственную Думу. Работа ведется постепенно, но каждая такая инициатива, закрепленная в законодательстве, постепенно улучшает качество жизни каждой российской семьи. Принимаемые меры позволяют развивать систему государственной поддержки семей с детьми и таким образом способствовать укреплению семейных уз. В конечном итоге они направлены на стимуляцию института многодетности, ведь дети — это квинтэссенция счастья, а счастья много не бывает.' | typograf }}
          </p>
        </div>
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          ШКОЛЫ В РОССИИ
        </h3>
      </div>
    </section>

    <div class="info">
      <div class="info__columns info__columns--pt">
        <div class="info__column">
          <div class="info__icon info__icon--1 img-w">
            <img src="@/assets/img/article5/i1.png" alt="">
          </div>
          <div>
            <div class="info__amount info__amount--a5">
              48<sup>тыс.</sup>
            </div>
            <div class="info__column-title">
              ШКОЛ
            </div>
          </div>
        </div>
        <div class="info__column">
          <div class="info__icon info__icon--2 img-w">
            <img src="@/assets/img/article5/i2.png" alt="">
          </div>
          <div>
            <div class="info__amount info__amount--a5">
              16,5<sup>млн.</sup>
            </div>
            <div class="info__column-title">
              УЧЕНИКОВ
            </div>
          </div>
        </div>
        <div class="info__column">
          <div class="info__icon info__icon--3 img-w">
            <img src="@/assets/img/article5/i3.png" alt="">
          </div>
          <div>
            <div class="info__amount info__amount--a5">
              2<sup>млн.</sup>
            </div>
            <div class="info__column-title">
              ПЕРВОКЛАШЕК
            </div>
          </div>
        </div>
      </div>
      <h3 class="info__title">
        {{ 'Братья и сестры могут:' | typograf }}
      </h3>
      <ul class="info__list">
        <li>ходить в один детский сад</li>
        <li>учиться в одной школе</li>
        <li>быть прописанными по любому адресу</li>
      </ul>
    </div>
  </div>
</template>

<script>
import './article.styl'
import './info.styl'
import Loading from '@/components/Loading/Loading.vue'
import Layers from '@/components/Layers/Layers.vue'
export default {
  name: 'Article5',
  data () {
    return {
      observer: null,
      isLoading: false,
      titles: [
        'Но внезапно у семьи возникли проблемы',
        'Казалось бы, у Елены были все права для зачисления дочери в ту же школу, где учится старший сын. Однако для отказа нашлась причина',
        '«Ситуация казалась безвыходной» <br> Елена Кульгина',
        'Поправки были подготовлены думской фракцией партии «Единая Россия»',
        '«Это закон — закон должен быть соблюден» <br> Светлана Бессараб',
        'Срок приоритетной подачи документов в учебное заведение — с 1 апреля до 30 июня',
        'Новые правила теперь действуют по всей стране',
        'Львова-Белова с супругом воспитывает девятерых детей и еще восемь ребят находится под ее опекой',
        '«Для каждой семьи важно иметь дополнительный ресурс для гармоничного развития ребенка»'
      ]
    }
  },
  components: {
    Loading, Layers
  },
  methods: {
    disable () {
      const target = document.querySelector('#app')
      target.ontouchstart = (e) => {
        e.preventDefault()
      }
    },
    enable () {
      const target = document.querySelector('#app')
      target.ontouchstart = () => {
        return true
      }
    },
    onDone () {
      (document.getElementById('element-container')).classList.remove('-scale', '-no-blue')
      document.querySelector('html').classList.remove('-lock')
      this.enable()
    },

    onIntersection (entries) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('-visible', entry.isIntersecting)

        if (entry.target.classList.contains('-visible')) {
          (document.getElementById('element-container')).classList.add('-scale')

          document.querySelector('html').classList.add('-lock')
          this.disable()
          this.isLoading = true

          setTimeout(() => {
            const layers = document.querySelectorAll('.bottom-layer')
            for (const layer of layers) {
              layer.classList.toggle('is-active')
            };

            this.$scrollTo('#element', 1800, { cancelable: false, offset: -60, onDone: this.onDone, onCancel: this.onDone })

            this.observer.disconnect()
          }, 1500)
        }
      })
    },

    initObserver () {
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,
        threshold: 0.5
      })

      const nodes = document.querySelectorAll('.observer-move')

      nodes.forEach((node) => {
        this.observer.observe(node)
      })
    }
  },
  mounted () {
    const titles = []

    this.titles.forEach((item) => {
      titles.push(item.split(' '))
    })
    this.titles = titles

    this.initObserver()
  }
}
</script>

<style scoped lang="stylus">
#element-container
  transition: all 1s ease-out

  &.-no-blue
    background #f9f9f9

    .article-cir__21, .article__line3
      opacity 0

  #element-content
    transform-origin 50% 0
    transition: all 0.4s ease-out

  &.-scale
    #element-content
      transition: none
      transform scale(0.8)

.article__img1
  position: absolute
  width: 23rem
  right: 0
  top: -9rem

.article__img2
  position: absolute
  width: 11rem
  left: 7rem
  top: 47rem

.article__img3
  position: absolute
  width: 50rem
  left: 0
  top: 0
  z-index: 15

.article__img4
  position: absolute;
  width: 55rem;
  right: 2rem;
  top: -42rem;
  z-index: 15;

  @media(max-width: 950px)
    float: right

.article__img5
  position: absolute
  width: 59rem
  left: 0
  top: 0
  z-index: 15

.article__line3
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__img6
  position: absolute
  width: 28rem
  right: 0
  top: 0

  @media(max-width: 950px)
    float: right
    width: 15rem
    margin: 0

.article__line4
  position: absolute
  width: 35rem
  left: 0
  top: 4rem
  z-index: 4

.article__img7
  position: absolute
  width: 29rem
  left: 0
  top: 85rem

  @media(max-width: 950px)
    display: none

.info__column
  @media(max-width: 950px)
    margin-bottom: 3.5rem
    margin-left: 2rem
    display: flex
    align-items: flex-end

.info__column-title
  @media(max-width: 950px)
    padding-bottom: 0

sup
  @media(max-width: 950px)
    top: -1.5rem
    margin-left: 0.5rem

.info__amount--a5
  @media(max-width: 950px)
    font-size: 5rem

.article__line5
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__line2
  position: absolute
  width: 47rem
  left: 0
  top: 2.5rem
  z-index: 14

.article__line6
  position: absolute
  right: 3rem
  top: 0
  width: 85rem

.article__img8
  position: absolute
  right: 0
  width: 20rem
  top: -24rem

.article__img9
  position: absolute
  left: 0
  width: 50rem
  top: -15rem

.article__img10
  position: absolute
  width: 10rem
  top: 225rem
  left: 6rem

.article__img11
  position: absolute
  width: 18rem
  right: 0
  top: -36rem

.article__img12
  position: absolute
  left: 0
  width: 25rem
  top: -40rem
</style>
